import moment from "moment";
import { Field, FieldRenderProps } from "react-final-form";
import { DatePicker, SelectInput, TextInput } from "@pickit/pickit-components";
import { InvoiceTypes } from "sagas/types/preliquidation";
import { DATE_FORMATS, VALIDATION_REGEX } from "utils/constants";
import { InvoiceDataCOProps } from "./types";
import "../../i18n";
import { useTranslation } from "react-i18next";

const InvoiceDataCO = ({
  isFormEnabled,
  minDate,
  invoiceTypes,
  testId,
}: InvoiceDataCOProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Field name="emisionDate">
        {({ input, meta }: FieldRenderProps<string>) => (
          <div>
            <DatePicker
              input={input}
              meta={meta}
              singleSelection
              outputFormat={DATE_FORMATS.shortDate}
              minDate={minDate as unknown as string}
              maxDate={moment() as unknown as string}
              disabled={!isFormEnabled}
              placeholder={t("invoice:dateOfIssuePlaceholder")}
              label={t("invoice:dateOfIssueLabel")}
              language="es"
              testId={`${testId}-field-emision-date`}
            />
          </div>
        )}
      </Field>

      <div>
        <Field name="invoiceType">
          {({ input, meta }: FieldRenderProps<InvoiceTypes | null>) => (
            <SelectInput
              input={{
                ...input,
                value: (input.value as InvoiceTypes)?.tag ?? input.value,
                onChange: (value: unknown) => {
                  const selected = invoiceTypes.find((o) => o.tag === (value as string));
                  input.onChange(selected ?? null);
                },
              }}
              meta={meta}
              label={t("invoice:voucherTypeLabel")}
              disabled={!isFormEnabled}
              testId={`${testId}-field-voucher-type`}
              placeholder={t("invoice:voucherTypePlaceholder")}
              options={invoiceTypes.map((o: InvoiceTypes) => ({
                ...o,
                label: o.name,
                value: o.tag,
              }))}
              showProperty="label"
              keyProperty="value"
            />
          )}
        </Field>
      </div>
      <Field
        disabled={!isFormEnabled}
        type="text"
        name="invoiceNumber"
        label={t("invoice:invoiceNumberLabel")}
        component={TextInput}
        pattern={VALIDATION_REGEX.regNumber}
        className="Admin-Pickers-input"
        placeholder={t("invoice:enterNumber")}
        maxLength={16}
        testId={`${testId}-field-invoice-number`}
      />
    </>
  );
};

export default InvoiceDataCO;
